<template>
  <a
    v-stat:click="{
      key: 'index_originality_blog_card_click',
      params: { o: data.id }
    }"
    :href="`https://hd.weibo.com/originality/view/${data.id}?alk_from=P006_C070`"
    target="_blank"
    class="ori-blog-component"
  >
    <div class="blog-content">
      <div v-if="data.profile_image_url" class="avatar-img">
        <img v-lazy="data.profile_image_url" class="app-lazyload-transparent" />
        <span
          v-if="data.verified_type - 0 !== -1"
          class="vip-badge"
          :class="{ bluev: data.verified_type - 0 === 2 }"
        >
          <i class="iconfont icon-yonghushuxing"></i>
        </span>
      </div>
      <div class="main-content">
        <div class="header">
          <div class="user-info">
            <h3 class="name">{{ data.screen_name }}</h3>
            <p>
              <span v-if="data.followers_count">
                粉丝·{{ data.followers_count | unit }}
              </span>
            </p>
          </div>
        </div>
        <div class="body">
          <div class="text-wrapper font-14">
            <div class="text" v-html="text"></div>
          </div>
          <div class="image-grid">
            <ul class="image-list">
              <li v-for="item in thumbnails" :key="item.id">
                <div class="image-item">
                  <img v-lazy="item.url" class="app-lazyload-transparent" />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer">
          <div class="relate-counts">
            <span v-if="data.repost_count > 0">
              转发 {{ data.repost_count | unit }} </span
            >,
            <span v-if="data.comment_count > 0">
              评论 {{ data.comment_count | unit }} </span
            >,
            <span v-if="data.attitude_count > 0">
              点赞 {{ data.attitude_count | unit }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  filters: {
    unit(value, d = 1) {
      const si = [
        { value: 1, symbol: '' },
        { value: 1e4, symbol: '万' },
        { value: 1e8, symbol: '亿' }
      ]
      let i
      for (i = si.length - 1; i > 0; i--) {
        if (value >= si[i].value) {
          break
        }
      }
      value = (value / si[i].value)
        .toFixed(d)
        .replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1')
      return value + si[i].symbol
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    text() {
      let text =
        this.data.is_long_text > 0 ? this.data.long_text : this.data.text
      return text
        .replace(/#(.*?)#/g, a => {
          return `<em>${a}</em>`
        })
        .replace(
          // eslint-disable-next-line
          /@(.*?)(?=[\x00-\x2C\x2E\x2F\x3A-\x40\x5B-\x5E\x60\x7B-\x7E\u3002\uff1f\uff01\uff0c\u3001\uff1b\uff1a\u201c\u201d\u2018\u2019\uff08\uff09\u300a\u300b\u3008\u3009\u3010\u3011\u300e\u300f\u300c\u300d\ufe43\ufe44\u3014\u3015\u2026\u2014\uff5e\ufe4f\uffe5])/g,
          a => {
            return `<em>${a}</em>`
          }
        )
        .replace('→http://t.cn/A6fmuHf5', '...')
    },
    thumbnails() {
      return (this.data.pic_list || [])
        .map(item => item.bmiddle || item.thumbnail || {})
        .map(item => {
          item.piiicMode = item.height - 0 > item.width * 2
          return item
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.ori-blog-component {
  width: 572px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.05);
  overflow: hidden;
  align-self: flex-start;
  box-sizing: border-box;
  color: white;
  display: block;
  padding: 25px 20px 32px;
  .avatar-img {
    float: left;
    width: 48px;
    height: 48px;
    padding-right: 12px;
    box-sizing: content-box;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
    .vip-badge {
      position: absolute;
      width: 14px;
      height: 14px;
      line-height: 15px;
      text-align: center;
      bottom: 0;
      right: 10px;
      border-radius: 50%;
      background-color: #ffa800;
      color: #ffffff;
      border: 2px solid #ffffff;
      i {
        font-size: 14px;
      }
      &.bluev {
        background-color: #2fb0f7;
      }
    }
    & + .main-content {
      .user-info {
        min-height: 48px;
      }
    }
  }
  .text-wrapper {
    margin: 8px 0;
  }
  .text {
    font-size: 14px;
    color: #ffffff;
    line-height: 22px;
    display: inline;
    word-break: break-all;
  }
  .main-content {
    overflow: hidden;
    .user-info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .name {
        font-size: 14px;
        line-height: normal;
      }
      p {
        color: #8e9091;
        font-size: 12px;
        span {
          margin-right: 12px;
        }
      }
    }
    .footer {
      display: flex;
      justify-content: flex-end;
      margin-top: 16px;
    }
  }
  .image-grid {
    width: 367px;
  }
  .image-list {
    list-style: none;
    margin: 0 -2.5px;
    padding: 0;
    overflow: hidden;
    li {
      float: left;
      width: 33.333333%;
      box-sizing: border-box;
      padding: 2.5px;
      position: relative;
      .mask {
        position: absolute;
        background-color: rgba(0, 0, 0, 0.45);
        top: 2.5px;
        left: 2.5px;
        right: 2.5px;
        bottom: 2.5px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        color: #ffffff;
        z-index: 1;
        border-radius: 4px;
      }
    }
    .image-item {
      display: block;
      width: 100%;
      position: relative;
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;
      img {
        width: 100%;
        position: absolute;
        height: 100%;
        object-fit: cover;
      }
      &:after {
        content: '';
        display: block;
        padding-bottom: 100%;
        height: 0;
      }
    }
  }
  .relate-counts {
    height: 30px;
    line-height: 31px;
    border-radius: 15px;
    padding: 0 16px;
    font-size: 14px;
    color: #efeff3;
    background-color: rgba(255, 255, 255, 0.1);
  }
}
</style>

<style lang="scss">
.ori-blog-component {
  .text {
    em {
      font-style: normal;
      color: #ffffff;
      font-weight: bold;
    }
  }
}
</style>
